import axios from "axios";
import { warehouseActions } from "../../../store/slices/warehouse";

export const c365devicesListDataId = "c365devicesListId";
export const c365devicesListId = "c365devicesListId";

// const UIText = {
//   "es-CL": {
//     start: "Forzando el reescaneo de equipos",
//     success: "Reescaneo solicitado exitosamente",
//     serverError: "Servidor retornó error",
//     error: "Error al intentar solicitar el rescaneo de un equipo",
//   },
//   "en-US": {
//     start: "Forcing devices to rescan data",
//     success: "Rescan requested successfully",
//     serverError: "Server returned error",
//     error: "Error while trying to request a rescan",
//   },
// };

const getC365List = (data) => {
  const { M365server, cloner_key, users } = data;

  return async (dispatch) => {
    // const { start, success, serverError, error } = UIText[locale];
    // dispatch(workerActions.start(forceRescanId));
    // enqueueSnackbar(start, { variant: "info" });

    try {
      let payload = {
        users: [...users],
      };

      // for (const item of payload) {
      const bodyData = JSON.stringify(payload);
      const url = new URL("mailapi/client/validate", M365server);
      const response = await axios.post(url, bodyData, {
        headers: { cloner_key },
      });

      // console.log("getC365List response: ", response.data);

      const users2 = response.data.data.users;

      // console.log("getC365List users2: ", users2);

      let machinesList = {}

      for (const item of users2) {
        // console.log("getC365List item: ", item);
        machinesList[item.user] = item.machine
      }
      
      dispatch(warehouseActions.load({
        id: c365devicesListDataId,
        data: machinesList,
      }));
      
    } catch (e) {
      console.error(e);
      // dispatch(workerActions.finish({ id: forceRescanId, error: e.msg }));
      // enqueueSnackbar(error, { variant: "error" });
    }
  };
};

export default getC365List;
